// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumErrorLevel } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
/**
 * 校验结果 实体类
 * 模型校验结果
 */
export class ValidationResult extends BaseEntity {
  /** 错误等级 : 错误等级 */
  private _errorLevel: EnumErrorLevel;

  /** 设置：错误等级 */
  public get errorLevel() {
    return this._errorLevel;
  }

  /** 获取：错误等级 */
  public set errorLevel(value: EnumErrorLevel) {
    this._errorLevel = value;
  }

  /** 校验结果信息 : 校验结果信息 */
  private _message: string;

  /** 设置：校验结果信息 */
  public get message() {
    return this._message;
  }

  /** 获取：校验结果信息 */
  public set message(value: string) {
    this._message = value;
  }

  /** 设计期ID : 发生错误的元素的设计期ID */
  private _designId: string;

  /** 设置：设计期ID */
  public get designId() {
    return this._designId;
  }

  /** 获取：设计期ID */
  public set designId(value: string) {
    this._designId = value;
  }

  /** 容器设计器ID : 容器设计器ID。如果发生错误的元素在一个容器图形中，需要设置容器，否则，设置自己作为容器，不能为空 */
  private _containerDesignId: string;

  /** 设置：容器设计器ID */
  public get containerDesignId() {
    return this._containerDesignId;
  }

  /** 获取：容器设计器ID */
  public set containerDesignId(value: string) {
    this._containerDesignId = value;
  }

  constructor() {
    super();
    this._errorLevel = EnumErrorLevel.Info;
    this._message = '';
    this._designId = '';
    this._containerDesignId = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ValidationResult, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.errorLevel = element.errorLevel;
      this.message = element.message;
      this.designId = element.designId;
      this.containerDesignId = element.containerDesignId;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.errorLevel = json.ErrorLevel as EnumErrorLevel;
    this.message = json.Message;
    this.designId = json.DesignId;
    this.containerDesignId = json.ContainerDesignId;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ErrorLevel = this.errorLevel;
    json.Message = this.message;
    json.DesignId = this.designId;
    json.ContainerDesignId = this.containerDesignId;
  }

  static Create(json: any): ValidationResult {
    const validationResult = new ValidationResult();
    validationResult.Deserialize(json);
    validationResult.json = json;
    return validationResult;
  }
}
